<agr-page-toolbar [pageTitle]="pageTitle$ | async" [hasPrimaryAction]="false">
  <div class="container">
    <agr-form [formGroup]="formGroup">
      <div>
        <mat-form-field class="spacing--margin-all">
          <mat-select formControlName="yearControl" placeholder="{{ 'selectYear' | translate }}" data-test="select-year">
            @for (year of years; track year) {
              <mat-option [value]="year" data-test="years-item">
                {{ year }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
      <div class="spacing--margin-all">
        <button mat-flat-button class="mat-flat-button mat-accent" data-test="download-report" (click)="downloadAdviceReport()">
          <mat-icon>cloud_download</mat-icon> {{ 'download' | translate }}
          {{ 'advice' | translate }}
        </button>
      </div>
      <div class="spacing--margin-all">
        <button mat-flat-button class="mat-flat-button mat-accent" data-test="download-report" (click)="downloadManureSpaceReport()">
          <mat-icon>cloud_download</mat-icon> {{ 'download' | translate }}
          {{ 'manurespace' | translate }}
        </button>
      </div>
    </agr-form>
  </div>
</agr-page-toolbar>
